import React, {memo, useCallback, useEffect, useState} from 'react';
import modClasses from '@mapsight/ui/src/js/helpers/mod-classes';
import {translate} from '@mapsight/ui/src/js/helpers/i18n';


const StarsField = memo(
	/**
	 * @param {{
	 *   value: null | number,
	 *   setRatingCallback?: null | (value: number) => void,
	 * }} props
	 */
	function StarsField({value, setRatingCallback, big}) {
		const step = setRatingCallback ? 1 : 0.5; // Das Fehlen von onChange signalisiert die Anzeige eines Durchschnittswerts
		const initialValue = value ?
			(setRatingCallback ? Math.round(value) : Math.round(value * 2) / 2) :
			0;
		const [val, setVal] = useState(initialValue);
		// changes from outside take precedence over form data
		useEffect(() => {
				setVal(initialValue);
			},
			[initialValue]
		);

		const handleChange = useCallback(e => {
				if (setRatingCallback) {
					const v = e.target.value < 1 ? 1 : Math.round(e.target.value);
					setVal(v);
					setRatingCallback(v);
				}
			},
			[setRatingCallback, setVal]
		);

		// we need min="1" to get the css calculations right, but then the initial click on the first start will be ignored.
		// that's why the additional onClick comes in.
		return (
			<div className="stade-stars-field">
				<label className="stade-stars-field__rating-label">
					<span className="visuallyhidden">`${translate('ratings.rating')}:`</span>
					<input
						className={modClasses("stade-stars-field__rating", {big})}
						min="1"
						max="5"
						type="range"
						step={step}
						value={val}
						style={{'--value': val}}
						readOnly={!setRatingCallback}
						onChange={handleChange}
						onClick={handleChange}
					/>
				</label>
			</div>
		);
	}
);

export default StarsField;
